import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import AdbIcon from "@mui/icons-material/Adb";
import { ThemeProvider, createTheme } from "@mui/material";
import { useNavigate, useLocation } from "react-router";
import { logoutUser } from "../src/features/user/userSlice";
import { clearExam } from "./features/exam/examSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

const pages = [];//["Exam", "Certificates"];
const settings = ["Account", "Admin", "Logout", "Users", "Codes"];

const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#FFF",
    },
    color: "#000",
  },
});

export default function ERAMenu() {
  const user = useSelector((state) => state.user.user);
  let location = useLocation();
  useEffect(() => {
    //allow the signup page to be hit by user
    if(location.pathname !== "/signup"){
    if (Object.keys(user).length === 0 && location.pathname !== "/") {
      navigate("/");
    }
    if (user.IsAdmin === false && location.pathname === "/admin") {
      navigate("/");
    }
  }
  }, [user, location.pathname]);
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = () => {
    dispatch(clearExam());
    dispatch(logoutUser());
    navigate("/");
  };

  return (
    <ThemeProvider theme={lightTheme}>
      <AppBar position="fixed">
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <img
              src="/logo.png"
              height="100px"
              width="300px"
              alt="COITB Logo"
            />

            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="black"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                }}
              >
                {pages.map((page) => (
                  <MenuItem key={page} onClick={handleCloseNavMenu}>
                    <Typography textAlign="center">{page}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>

            <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
              {pages.map((page) => (
                <Button
                  key={page}
                  onClick={() => {
                    handleCloseNavMenu();
                    console.log(page.toLowerCase());
                    navigate(`/${page.toLowerCase()}`);
                  }}
                  sx={{ my: 2, color: "black", display: "block" }}
                >
                  {page}
                </Button>
              ))}
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "25%",
              }}
            >
              <Typography sx={{ color: "black" }}>
                Welcome: {user.FirstName} {user.LastName}
              </Typography>
            </Box>
            <Box
              sx={{
                flexGrow: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem
                    key={setting}
                    sx={
                    user.IsAdmin !== true && setting === "Admin"
                        ? { display: "none" }
                        : {}
                    }
                    onClick={() => {
                      handleCloseUserMenu();
                      if (setting === "Logout") {
                        handleLogout();
                      }
                      if (setting === "Admin" && user.IsAdmin === true) {
                        navigate("/admin");
                      }

                      if(setting === "Users" && user.IsAdmin === true){
                        navigate("/add-user");
                      }

                      if(setting === "Codes" && user.IsAdmin === true){
                        navigate("/users/examassignment")
                      }
                    }}
                  >
                    <Typography textAlign="center">{setting}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </ThemeProvider>
  );
}
